import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetCustomFieldTemplate = function () {
    return useApiCall(function (signal) { return api.customSections.apiCustomFieldSectionTemplateGet({ signal: signal }); }, [], true, []);
};
